import { appSchema, tableSchema } from "@nozbe/watermelondb";

export const GROUP_PAYMENT_LEDGER_SCHEMA = "group_payment_ledger";
export const CUSTOMER_ACCOUNTS_SCHEMA = "customer_accounts";
export const ANALYTICS_EVENTS_SCHEMA = "analytics_events";
export const SURVEY_RESPONSES_SCHEMA = "survey_responses";
export const INVOICE_PAYMENTS_SCHEMA = "invoice_payments";
export const CASHBOOK_CATEGORIES = "cashbook_categories";
export const POS_ORDERS_LINE_SCHEMA = "pos_order_lines";
export const SETTINGS_CONFIG_SCHEMA = "settings_config";
export const RATE_LIST_LINES_SCHEMA = "rate_list_lines";
export const SALE_ORDER_LINE_SCHEMA = "sale_order_line";
export const GROUP_CUSTOMER_SCHEMA = "group_customers";
export const WISHLIST_ITEMS_SCHEMA = "wishlist_items";
export const GROUP_PAYMENT_SCHEMA = "group_payments";
export const BUSINESS_CARD_SCHEMA = "business_card";
export const NOTIFICATIONS_SCHEMA = "notifications";
export const DISPUTES_SCHEMA = "recharge_disputes";
export const TRUSTED_LIST_SCHEMA = "trusted_list";
export const CATEGORY_SCHEMA = "stock_categories";
export const GUIDED_TOURS_SCHEMA = "guided_tours";
export const POS_ORDERS_SCHEMA = "pos_orders";
export const ATTENDANCE_SCHEMA = "attendance";
export const INVENTORY_SCHEMA = "stock_moves";
export const SALE_ORDER_SCHEMA = "sale_order";
export const SIGNATURES_SCHEMA = "signatures";
export const RECHARGE_SCHEMA = "wallet_txns";
export const INAPP_SCHEMA = "inapp_messages";
export const LAST_SYNC_SCHEMA = "last_sync";
export const RATE_LIST_SCHEMA = "rate_list";
export const BUSINESS_SCHEMA = "business";
export const CUSTOMER_SCHEMA = "customer";
export const WISHLIST_SCHEMA = "wishlist";
export const CONTACTS_SCHEMA = "contacts";
export const PAYMENT_SCHEMA = "payment";
export const JOURNAL_SCHEMA = "journal";
export const INVOICE_SCHEMA = "invoice";
export const ADDRESS_SCHEMA = "address";
export const CART_ITEMS = "cart_items";
export const ORDERS_SCHEMA = "orders";
export const POS_TXNS_SCHEMA = "txns";
export const GROUP_SCHEMA = "groups";
export const NUDGE_SCHEMA = "nudge";
export const STAFF_SCHEMA = "staff";
export const STOCK_SCHEMA = "stock";
export const USER_SCHEMA = "user";
export const CART_SCHEMA = "cart";
export const UNIT_SCHEMA = "unit";
export const COMPANY = "company";
export const CASH_TXN_SCHEMA = 'cash_txn';

export const mySchema = appSchema({
  version: 38,
  tables: [
    tableSchema({
      name: USER_SCHEMA,
      columns: [
        { name: "alternate_number", type: "string", isOptional: true },
        { name: "activation_code", type: "string", isOptional: true },
        { name: "bank_account_no", type: "string", isOptional: true },
        { name: "telco_network", type: "string", isOptional: true },
        { name: "account_type", type: "string", isOptional: true },
        { name: "device_token", type: "string", isOptional: true },
        { name: "has_wallet", type: "boolean", isOptional: true },
        { name: "is_active", type: "boolean", isOptional: true },
        { name: "currency", type: "string", isOptional: true },
        { name: "referral", type: "string", isOptional: true },
        { name: "country", type: "string", isOptional: true },
        { name: "name", type: "string", isOptional: true },
        { name: "type", type: "string", isOptional: true },
        { name: "bank", type: "string", isOptional: true },
        { name: "phone_number", type: "string" },
        { name: "is_synced", type: "boolean" },
      ],
    }),
    tableSchema({
      name: BUSINESS_SCHEMA,
      columns: [
        {
          name: "online_payments_activated",
          type: "boolean",
          isOptional: true,
        },
        { name: "invoice_number_prefix", type: "string", isOptional: true },
        { name: "last_contact_sync_at", type: "number", isOptional: true },
        { name: "beneficiary_name", type: "string", isOptional: true },
        { name: "alternate_number", type: "string", isOptional: true },
        { name: "pos_order_count", type: "number", isOptional: true },
        { name: "account_number", type: "string", isOptional: true },
        { name: "card_template", type: "number", isOptional: true },
        { name: "sms_template", type: "string", isOptional: true },
        { name: "new_category", type: "string", isOptional: true },
        { name: "connected", type: "boolean", isOptional: true },
        { name: "is_active", type: "boolean", isOptional: true },
        { name: "report_url", type: "string", isOptional: true },
        { name: "bank_name", type: "string", isOptional: true },
        { name: "longitude", type: "number", isOptional: true },
        { name: "image_url", type: "string", isOptional: true },
        { name: "personal", type: "boolean", isOptional: true },
        { name: "category", type: "string", isOptional: true },
        { name: "latitude", type: "number", isOptional: true },
        { name: "landmark", type: "string", isOptional: true },
        { name: "province", type: "string", isOptional: true },
        { name: "address", type: "string", isOptional: true },
        { name: "contact", type: "string", isOptional: true },
        { name: "printer", type: "string", isOptional: true },
        { name: "d2_at", type: "number", isOptional: true },
        { name: "d1_at", type: "number", isOptional: true },
        { name: "city", type: "string", isOptional: true },
        { name: "area", type: "string", isOptional: true },
        { name: "sntn", type: "string", isOptional: true },
        { name: "iban", type: "string", isOptional: true },
        { name: "name", type: "string", isOptional: true },
        { name: "ntn", type: "string", isOptional: true },
        { name: "invoice_number_count", type: "number" },
        { name: "expense_number_count", type: "number" },
        { name: "quick_sale_number_count", type: "number" },
        { name: "last_active_at", type: "number" },
        { name: "favourites", type: "string" },
        { name: "is_synced", type: "boolean" },
        { name: "user_id", type: "string" },
        { name: "type", type: "string" },
        { name: 'cashbook_migrated', type: 'boolean', isOptional: true },

      ],
    }),
    tableSchema({
      name: BUSINESS_CARD_SCHEMA,
      columns: [
        { name: "business_category", type: "string", isOptional: true },
        { name: "contact_name", type: "string", isOptional: true },
        { name: "about_us", type: "string", isOptional: true },
        { name: "address", type: "string", isOptional: true },
        { name: "email", type: "string", isOptional: true },
        { name: "business_name", type: "string" },
        { name: "phone_number", type: "string" },
        { name: "business_id", type: "string" },
      ],
    }),
    tableSchema({
      name: STOCK_SCHEMA,
      columns: [
        { name: "minimum_order_quantity", type: "number", isOptional: true },
        { name: "manufacturing_date", type: "number", isOptional: true },
        { name: "unit_conversion", type: "number", isOptional: true },
        { name: "wholesale_price", type: "number", isOptional: true },
        { name: "secondary_unit", type: "string", isOptional: true },
        { name: "selling_price", type: "number", isOptional: true },
        { name: "batch_number", type: "number", isOptional: true },
        { name: "expiry_alert", type: "number", isOptional: true },
        { name: "expiry_date", type: "number", isOptional: true },
        { name: "category_id", type: "string", isOptional: true },
        { name: "inclusive", type: "boolean", isOptional: true },
        { name: "cost_price", type: "number", isOptional: true },
        { name: "catalog_id", type: "string", isOptional: true },
        { name: "archived", type: "boolean", isOptional: true },
        { name: "image_url", type: "string", isOptional: true },
        { name: "low_stock", type: "number", isOptional: true },
        { name: "bar_code", type: "number", isOptional: true },
        { name: "barcode", type: "number", isOptional: true },
        { name: "stock", type: "number", isOptional: true },
        { name: "unit", type: "string", isOptional: true },
        { name: "imei", type: "number", isOptional: true },
        { name: "tax", type: "number", isOptional: true },
        { name: "sku", type: "string", isOptional: true },
        { name: "business_id", type: "string" },
        { name: "is_synced", type: "boolean" },
        { name: "created_at", type: "number" },
        { name: "name", type: "string" },
      ],
    }),
    tableSchema({
      name: CUSTOMER_SCHEMA,
      columns: [
        { name: "last_transaction_at", type: "number", isOptional: true },
        { name: "collection_set_at", type: "number", isOptional: true },
        { name: "reminder_type", type: "string", isOptional: true },
        { name: "collect_at", type: "number", isOptional: true },
        { name: "payment_at", type: "number", isOptional: true },
        { name: "image_url", type: "string", isOptional: true },
        { name: "viewed_at", type: "number", isOptional: true },
        { name: "web_link", type: "string", isOptional: true },
        { name: "total_outstanding_payment", type: "number" },
        { name: "email", type: "string", isOptional: true },
        { name: "phone", type: "string", isOptional: true },
        { name: "sms", type: "string", isOptional: true },
        { name: "transaction_sms", type: "boolean" },
        { name: "is_supplier", type: "boolean" },
        { name: "business_id", type: "string" },
        { name: "created_at", type: "number" },
        { name: "is_synced", type: "boolean" },
        { name: "readonly", type: "boolean" },
        { name: "name", type: "string" },
        { name: 'is_personal', type: 'boolean' },

      ],
    }),
    tableSchema({
      name: PAYMENT_SCHEMA,
      columns: [
        { name: "cash_txn_id", type: "string", isOptional: true },
        { name: "wallet_txns_id", type: "string", isOptional: true },
        { name: "external_type", type: "string", isOptional: true },
        { name: "udhaar_note", type: "string", isOptional: true },
        { name: "invoice_id", type: "string", isOptional: true },
        { name: "image_url", type: "string", isOptional: true },
        { name: "recording", type: "string", isOptional: true },
        { name: "txns_id", type: "string", isOptional: true },
        { name: "type", type: "string", isOptional: true },
        { name: "category", type: "string", isOptional: true },
        { name: "attachment", type: "string", isOptional: true },
        { name: "transacted_at", type: "number" },
        { name: "payment_mode", type: "string" },
        { name: "business_id", type: "string" },
        { name: "customer_id", type: "string" },
        { name: "is_synced", type: "boolean" },
        { name: "created_at", type: "number" },
        { name: "amount", type: "number" },
      ],
    }),
    tableSchema({
      name: STAFF_SCHEMA,
      columns: [
        { name: "last_updated_at", type: "number", isOptional: true },
        { name: "account_number", type: "string", isOptional: true },
        { name: "payment_method", type: "string", isOptional: true },
        { name: "profile_image", type: "string", isOptional: true },
        { name: "phone_number", type: "string", isOptional: true },
        { name: "joined_at", type: "number", isOptional: true },
        { name: "workdays", type: "string", isOptional: true },
        { name: "cnic", type: "string", isOptional: true },
        { name: "auto_present", type: "boolean" },
        { name: "working_hours", type: "number" },
        { name: "open_balance", type: "number" },
        { name: "business_id", type: "string" },
        { name: "salary_type", type: "string" },
        { name: "created_at", type: "number" },
        { name: "is_synced", type: "boolean" },
        { name: "sms_alert", type: "string" },
        { name: "job_title", type: "string" },
        { name: "salary", type: "number" },
        { name: "name", type: "string" },
      ],
    }),
    tableSchema({
      name: ATTENDANCE_SCHEMA,
      columns: [
        { name: "total_minutes", type: "number", isOptional: true },
        { name: "extra_payment", type: "number", isOptional: true },
        { name: "journal_id", type: "string", isOptional: true },
        { name: "extra_mode", type: "string", isOptional: true },
        { name: "work_name", type: "string", isOptional: true },
        { name: "work_rate", type: "number", isOptional: true },
        { name: "work_unit", type: "number", isOptional: true },
        { name: "wage", type: "number", isOptional: true },
        { name: "note", type: "string", isOptional: true },
        { name: "last_updated_at", type: "number" },
        { name: "attendance_at", type: "number" },
        { name: "check_out_at", type: "number" },
        { name: "business_id", type: "string" },
        { name: "check_in_at", type: "number" },
        { name: "staff_id", type: "string" },
        { name: "payment", type: "number" },
        { name: "status", type: "string" },
      ],
    }),
    tableSchema({
      name: JOURNAL_SCHEMA,
      columns: [
        { name: "last_updated_at", type: "number" },
        { name: "reference_id", type: "string" },
        { name: "business_id", type: "string" },
        { name: "description", type: "string" },
        { name: "created_at", type: "number" },
        { name: "staff_id", type: "string" },
        { name: "amount", type: "number" },
        { name: "type", type: "string" },
      ],
    }),
    tableSchema({
      name: INVOICE_SCHEMA,
      columns: [
        { name: "supplier_order_id", type: "number", isOptional: true },
        { name: "invoice_prefix", type: "string", isOptional: true },
        { name: "sales_amount", type: "number", isOptional: true },
        { name: "document_url", type: "string", isOptional: true },
        { name: "customer_id", type: "string", isOptional: true },
        { name: "cost_amount", type: "number", isOptional: true },
        { name: "company_id", type: "string", isOptional: true },
        { name: "attachment", type: "string", isOptional: true },
        { name: "recording", type: "string", isOptional: true },
        { name: "image_url", type: "string", isOptional: true },
        { name: "signature", type: "string", isOptional: true },
        { name: "tranType", type: "string", isOptional: true },
        { name: "category", type: "string", isOptional: true },
        { name: "status", type: "string", isOptional: true },
        { name: "method", type: "string", isOptional: true },
        { name: "wallet", type: "string", isOptional: true },
        { name: "profit", type: "number", isOptional: true },
        { name: "note", type: "string", isOptional: true },
        { name: "bank", type: "string", isOptional: true },
        { name: "invoice_number", type: "string" },
        { name: "advance_amount", type: "number" },
        { name: "signatures_id", type: "string" },
        { name: "invoice_title", type: "string" },
        { name: "discount_unit", type: "string" },
        { name: "transacted_at", type: "number" },
        { name: "due_date", type: "number" },
        { name: "business_id", type: "string" },
        { name: "is_synced", type: "boolean" },
        { name: "created_at", type: "number" },
        { name: "sub_total", type: "number" },
        { name: "tax_title", type: "string" },
        { name: "discount", type: "number" },
        { name: "tax_rate", type: "number" },
        { name: "amount", type: "number" },
        { name: "total", type: "number" },
        { name: "type", type: "string" },
        { name: "reference_id", type: "string", isOptional: true },
        { name: "change_amount", type: "number" },
      ],
      // Covering index for useBusinessFinancials' sale/expense invoice lookups and the
      // orders join used for the "expense invoices without orders" check and COGS sum —
      // without it those run as a full table scan per business on the invoice table.
      unsafeSql: sql =>
        sql +
        'create index if not exists "invoice_business_type_transacted_covering" on "invoice" ("business_id", "type", "transacted_at");',


    }),
    tableSchema({
      name: CASH_TXN_SCHEMA,
      columns: [
        { name: "business_id", type: "string" },
        { name: "customer_id", type: "string", isOptional: true },
        { name: "sales_amount", type: "number", isOptional: true },
        { name: "cost_amount", type: "number", isOptional: true },
        { name: "amount", type: "number" },
        { name: "transacted_at", type: "number" },
        { name: "image_url", type: "string", isOptional: true },
        { name: "note", type: "string", isOptional: true },
        { name: "status", type: "string", isOptional: true },
        { name: "tranType", type: "string", isOptional: true },
        { name: "method", type: "string", isOptional: true },
        { name: "type", type: "string" },
        { name: "bank", type: "string", isOptional: true },
        { name: "wallet", type: "string", isOptional: true },
        { name: "category", type: "string", isOptional: true },
        { name: "recording", type: "string", isOptional: true },
        { name: "is_synced", type: "boolean" },
        { name: "total", type: "number" },
        { name: "sub_total", type: "number" },
        { name: "discount", type: "number" },
        { name: "discount_unit", type: "string" },
        { name: "tax_title", type: "string" },
        { name: "tax_rate", type: "number" },
        { name: "advance_amount", type: "number" },
        { name: "invoice_title", type: "string" },
        { name: "invoice_number", type: "string" },
        { name: "attachment", type: "string", isOptional: true },
        { name: "invoice_prefix", type: "string", isOptional: true },
        { name: "signature", type: "string", isOptional: true },
        { name: "profit", type: "number", isOptional: true },
        { name: "document_url", type: "string", isOptional: true },
        { name: "created_at", type: "number" },
        { name: "wallet_txns_id", type: "string", isOptional: true },
      ],
      // Covering index for the cashbook net-balance aggregate (business_id + date range,
      // summing amount by type): every column the query touches is in the index, so SQLite
      // answers it straight from the index B-tree without visiting the table's row pages —
      // which is what matters here, since those pages also hold the large recording/
      // signature/attachment/document_url blobs this query has no use for.
      unsafeSql: sql =>
        sql +
        'create index if not exists "cash_txn_business_transacted_covering" on "cash_txn" ("business_id", "transacted_at", "amount", "type", "_status");',

    }),
    tableSchema({
      name: ORDERS_SCHEMA,
      columns: [
        { name: "is_secondary_unit", type: "boolean", isOptional: true },
        { name: "unit_conversion", type: "number", isOptional: true },
        { name: "discount_method", type: "string", isOptional: true },
        { name: "secondary_unit", type: "string", isOptional: true },
        { name: "transacted_at", type: "number", isOptional: true },
        { name: "selling_price", type: "number", isOptional: true },
        { name: "is_open_item", type: "boolean", isOptional: true },
        { name: "inclusive", type: "boolean", isOptional: true },
        { name: "payment_id", type: "string", isOptional: true },
        { name: "cost_price", type: "number", isOptional: true },
        { name: "tran_type", type: "string", isOptional: true },
        { name: "discount", type: "number", isOptional: true },
        { name: "stock_id", type: "string", isOptional: true },
        { name: "txns_id", type: "string", isOptional: true },
        { name: "type", type: "string", isOptional: true },
        { name: "unit", type: "string", isOptional: true },
        { name: "tax", type: "number", isOptional: true },
        { name: "business_id", type: "string" },
        { name: "invoice_id", type: "string" },
        { name: "quantity", type: "number" },
        { name: "name", type: "string" },
      ],
    }),
    tableSchema({
      name: CONTACTS_SCHEMA,
      columns: [
        { name: "customer_id", type: "string", isOptional: true },
        { name: "contact_id", type: "string" },
        { name: "user_id", type: "string" },
        { name: "phone", type: "string" },
        { name: "name", type: "string" },
        { name: "hash", type: "string" },
      ],
    }),
    tableSchema({
      name: LAST_SYNC_SCHEMA,
      columns: [
        { name: "last_sync_at", type: "number" },
        { name: "user_id", type: "string" },
      ],
    }),
    tableSchema({
      name: INVENTORY_SCHEMA,
      columns: [
        { name: 'order_id', type: 'string', isOptional: true },
        { name: "is_secondary_unit", type: "boolean", isOptional: true },
        { name: "unit_conversion", type: "number", isOptional: true },
        { name: "price", type: "number", isOptional: true },
        { name: "transacted_at", type: "number" },
        { name: "stock_id", type: "string" },
        { name: "quantity", type: "number" },
        { name: "name", type: "string" },
        { name: "type", type: "string" },
        { name: 'refrence_id', type: 'string', isOptional: true },
        { name: 'table_name', type: 'string', isOptional: true },
        { name: 'tran_type', type: 'string', isOptional: true },

      ],
    }),
    tableSchema({
      name: RECHARGE_SCHEMA,
      columns: [
        { name: "transaction_status", type: "string", isOptional: true },
        { name: "transferred_to", type: "string", isOptional: true },
        { name: "dispute_status", type: "string", isOptional: true },
        { name: "transaction_id", type: "string", isOptional: true },
        { name: "customer_name", type: "string", isOptional: true },
        { name: "deposited_by", type: "string", isOptional: true },
        { name: "reference_id", type: "string", isOptional: true },
        { name: "commission", type: "number", isOptional: true },
        { name: "to_account", type: "string", isOptional: true },
        { name: "offer_name", type: "string", isOptional: true },
        { name: "cash_back", type: "number", isOptional: true },
        { name: "offer_key", type: "string", isOptional: true },
        { name: "customer", type: "string", isOptional: true },
        { name: "payment_mode", type: "string" },
        { name: "business_id", type: "string" },
        { name: "created_at", type: "number" },
        { name: "service", type: "string" },
        { name: "balance", type: "number" },
        { name: "amount", type: "number" },
        { name: "type", type: "string" },
        { name: "mode", type: "string" },
      ],
    }),
    tableSchema({
      name: INAPP_SCHEMA,
      columns: [
        { name: "description_json", type: "string", isOptional: true },
        { name: "result", type: "string", isOptional: true },
        { name: "business_id", type: "string" },
        { name: "description", type: "string" },
        { name: "pending", type: "boolean" },
        { name: "shown_at", type: "number" },
        { name: "action", type: "string" },
        { name: "title", type: "string" },
        { name: "cta", type: "string" },
      ],
    }),
    tableSchema({
      name: DISPUTES_SCHEMA,
      columns: [
        { name: "customer_number", type: "string" },
        { name: "wallet_txns_id", type: "string" },
        { name: "telco_network", type: "string" },
        { name: "business_id", type: "string" },
        { name: "created_at", type: "number" },
        { name: "status", type: "string" },
        { name: "amount", type: "number" },
      ],
    }),
    tableSchema({
      name: CATEGORY_SCHEMA,
      columns: [
        { name: "reference_id", type: "string" },
        { name: "business_id", type: "string" },
        { name: "image_url", type: "string" },
        { name: "level", type: "string" },
        { name: "name", type: "string" },
      ],
    }),
    tableSchema({
      name: POS_ORDERS_SCHEMA,
      columns: [
        { name: "customer_id", type: "string", isOptional: true },
        { name: "image_url", type: "string", isOptional: true },
        { name: "method", type: "string", isOptional: true },
        { name: "note", type: "string", isOptional: true },
        { name: "tax", type: "number", isOptional: true },
        { name: "amount_received", type: "number" },
        { name: "transacted_at", type: "number" },
        { name: "business_id", type: "string" },
        { name: "amount", type: "number" },
        { name: "count", type: "number" },
      ],
    }),
    tableSchema({
      name: POS_ORDERS_LINE_SCHEMA,
      columns: [
        { name: "selling_price", type: "number", isOptional: true },
        { name: "transacted_at", type: "number", isOptional: true },
        { name: "cost_price", type: "number", isOptional: true },
        { name: "stock_id", type: "string", isOptional: true },
        { name: "unit", type: "string", isOptional: true },
        { name: "type", type: "string", isOptional: true },
        { name: "pos_order_id", type: "string" },
        { name: "business_id", type: "string" },
        { name: "quantity", type: "number" },
        { name: "name", type: "string" },
      ],
    }),
    tableSchema({
      name: CART_SCHEMA,
      columns: [
        { name: "customer_id", type: "string", isOptional: true },
        { name: "business_id", type: "string" },
        { name: "created_at", type: "number" },
      ],
    }),
    tableSchema({
      name: CART_ITEMS,
      columns: [
        { name: "variant_name", type: "string", isOptional: true },
        { name: "supplier_id", type: "string", isOptional: true },
        { name: "variant_id", type: "string", isOptional: true },
        { name: "cost_price", type: "number", isOptional: true },
        { name: "totalStock", type: "number", isOptional: true },
        { name: "image_url", type: "string", isOptional: true },
        { name: "discount", type: "number", isOptional: true },
        { name: "stock_id", type: "string", isOptional: true },
        { name: "unit", type: "string", isOptional: true },
        { name: "tax", type: "number", isOptional: true },
        { name: "product_name", type: "string" },
        { name: "product_id", type: "string" },
        { name: "quantity", type: "number" },
        { name: "cart_id", type: "string" },
        { name: "price", type: "number" },
      ],
    }),
    tableSchema({
      name: ADDRESS_SCHEMA,
      columns: [
        { name: "instructions", type: "string", isOptional: true },
        { name: "shop_number", type: "string", isOptional: true },
        { name: "longitude", type: "number", isOptional: true },
        { name: "shop_name", type: "string", isOptional: true },
        { name: "latitude", type: "number", isOptional: true },
        { name: "province", type: "string", isOptional: true },
        { name: "building", type: "string", isOptional: true },
        { name: "address", type: "string", isOptional: true },
        { name: "floor", type: "string", isOptional: true },
        { name: "city", type: "string", isOptional: true },
        { name: "area", type: "string", isOptional: true },
        { name: "user_id", type: "string" },
      ],
    }),
    tableSchema({
      name: UNIT_SCHEMA,
      columns: [
        { name: "business_id", type: "string" },
        { name: "name", type: "string" },
      ],
    }),
    tableSchema({
      name: INVOICE_PAYMENTS_SCHEMA,
      columns: [
        { name: "business_id", type: "string" },
        { name: "invoice_id", type: "string" },
        { name: "created_at", type: "number" },
        { name: "wallet", type: "string" },
        { name: "amount", type: "number" },
        { name: "method", type: "string" },
        { name: "bank", type: "string" },
      ],
    }),
    tableSchema({
      name: SALE_ORDER_SCHEMA,
      columns: [
        { name: "customer_id", type: "string", isOptional: true },
        { name: "discount", type: "number", isOptional: true },
        { name: "tax", type: "number", isOptional: true },
        { name: "discount_unit", type: "string" },
        { name: "business_id", type: "string" },
        { name: "created_at", type: "number" },
        { name: "tax_type", type: "string" },
        { name: "status", type: "string" },
        { name: "note", type: "string" },
      ],
    }),
    tableSchema({
      name: SALE_ORDER_LINE_SCHEMA,
      columns: [
        { name: "is_secondary_unit", type: "boolean", isOptional: true },
        { name: "discount_method", type: "string", isOptional: true },
        { name: "unit_conversion", type: "number", isOptional: true },
        { name: "secondary_unit", type: "string", isOptional: true },
        { name: "is_open_item", type: "boolean", isOptional: true },
        { name: "selling_price", type: "number", isOptional: true },
        { name: "transacted_at", type: "number", isOptional: true },
        { name: "inclusive", type: "boolean", isOptional: true },
        { name: "cost_price", type: "number", isOptional: true },
        { name: "tran_type", type: "string", isOptional: true },
        { name: "discount", type: "number", isOptional: true },
        { name: "stock_id", type: "string", isOptional: true },
        { name: "type", type: "string", isOptional: true },
        { name: "unit", type: "string", isOptional: true },
        { name: "tax", type: "number", isOptional: true },
        { name: "sale_order_id", type: "string" },
        { name: "quantity", type: "number" },
        { name: "name", type: "string" },
      ],
    }),
    tableSchema({
      name: POS_TXNS_SCHEMA,
      columns: [
        { name: "discount_unit", type: "string", isOptional: true },
        { name: "customer_id", type: "string", isOptional: true },
        { name: "discount", type: "number", isOptional: true },
        { name: "note", type: "string", isOptional: true },
        { name: "payment_method", type: "string" },
        { name: "change_amount", type: "number" },
        { name: "business_id", type: "string" },
        { name: "created_at", type: "number" },
        { name: "tax_type", type: "string" },
        { name: "amount", type: "number" },
        { name: "trnsId", type: "string" },
        { name: "status", type: "string" },
        { name: "type", type: "string" },
        { name: "tax", type: "number" },
      ],
    }),
    tableSchema({
      name: CASHBOOK_CATEGORIES,
      columns: [
        { name: "business_id", type: "string" },
        { name: "name", type: "string" },
      ],
    }),
    tableSchema({
      name: COMPANY,
      columns: [
        { name: "business_id", type: "string" },
        { name: "name", type: "string" },
      ],
    }),
    tableSchema({
      name: GROUP_SCHEMA,
      columns: [
        { name: "group_type", type: "string", isOptional: true },
        { name: "image_url", type: "string", isOptional: true },
        { name: "payment_received", type: "number" },
        { name: "business_id", type: "string" },
        { name: "collect_at", type: "number" },
        { name: "amount", type: "number" },
        { name: "count", type: "number" },
        { name: "name", type: "string" },
        { name: "type", type: "string" },
      ],
    }),
    tableSchema({
      name: GROUP_PAYMENT_SCHEMA,
      columns: [
        { name: "processed", type: "boolean" },
        { name: "collect_at", type: "number" },
        { name: "group_id", type: "string" },
        { name: "amount", type: "number" },
        { name: "type", type: "string" },
      ],
    }),
    tableSchema({
      name: GROUP_CUSTOMER_SCHEMA,
      columns: [
        { name: "total_outstanding_payment", type: "number" },
        { name: "customer_id", type: "string" },
        { name: "group_id", type: "string" },
      ],
    }),
    tableSchema({
      name: CUSTOMER_ACCOUNTS_SCHEMA,
      columns: [
        { name: "account_number", type: "string" },
        { name: "customer_id", type: "string" },
        { name: "title", type: "string" },
        { name: "bank", type: "string" },
        { name: "type", type: "string" },
      ],
    }),
    tableSchema({
      name: GROUP_PAYMENT_LEDGER_SCHEMA,
      columns: [
        { name: "image_url", type: "string", isOptional: true },
        { name: "recording", type: "string", isOptional: true },
        { name: "group_id", type: "string", isOptional: true },
        { name: "wallet", type: "string", isOptional: true },
        { name: "method", type: "string", isOptional: true },
        { name: "type", type: "string", isOptional: true },
        { name: "note", type: "string", isOptional: true },
        { name: "bank", type: "string", isOptional: true },
        { name: "group_payment_id", type: "string" },
        { name: "transacted_at", type: "number" },
        { name: "payment_mode", type: "string" },
        { name: "business_id", type: "string" },
        { name: "customer_id", type: "string" },
        { name: "created_at", type: "number" },
        { name: "amount", type: "number" },
        { name: 'attachment', type: 'string', isOptional: true },
      ],
    }),
    tableSchema({
      name: TRUSTED_LIST_SCHEMA,
      columns: [
        { name: "type", type: "string", isOptional: true },
        { name: "business_id", type: "string" },
        { name: "number", type: "string" },
        { name: "name", type: "string" },
      ],
    }),
    tableSchema({
      name: ANALYTICS_EVENTS_SCHEMA,
      columns: [
        { name: "updated_at", type: "number" },
        { name: "is_fired", type: "boolean" },
        { name: "user_id", type: "string" },
        { name: "count", type: "number" },
        { name: "name", type: "string" },
      ],
    }),
    tableSchema({
      name: SURVEY_RESPONSES_SCHEMA,
      columns: [
        { name: "secondary_answer", type: "string", isOptional: true },
        { name: "business_id", type: "string" },
        { name: "question", type: "string" },
        { name: "options", type: "string" },
        { name: "answer", type: "string" },
        { name: "type", type: "string" },
      ],
    }),
    tableSchema({
      name: WISHLIST_SCHEMA,
      columns: [
        { name: "created_at", type: "number" },
        { name: "user_id", type: "string" },
      ],
    }),
    tableSchema({
      name: WISHLIST_ITEMS_SCHEMA,
      columns: [
        { name: "variant_id", type: "number", isOptional: true },
        { name: "wishlist_id", type: "string" },
        { name: "product_id", type: "number" },
      ],
    }),
    tableSchema({
      name: NOTIFICATIONS_SCHEMA,
      columns: [
        { name: "supplier_id", type: "string", isOptional: true },
        { name: "web_slug", type: "string", isOptional: true },
        { name: "supplier_order_number", type: "number" },
        { name: "customer_order_number", type: "number" },
        { name: "sync_timestamp_unix", type: "number" },
        { name: "supplier_image", type: "string" },
        { name: "session_key", type: "string" },
        { name: "created_at", type: "number" },
        { name: "btn_title", type: "string" },
        { name: "cta_color", type: "string" },
        { name: "btn_color", type: "string" },
        { name: "btn_icon", type: "string" },
        { name: "supplier", type: "string" },
        { name: "user_id", type: "string" },
        { name: "favicon", type: "string" },
        { name: "message", type: "string" },
        { name: "status", type: "string" },
        { name: "title", type: "string" },
        { name: "type", type: "string" },
      ],
    }),
    tableSchema({
      name: NUDGE_SCHEMA,
      columns: [
        { name: "total_step_count", type: "number" },
        { name: "completed_count", type: "number" },
        { name: "completed_steps", type: "string" },
        { name: "user_id", type: "string" },
        { name: "name", type: "string" },
      ],
    }),
    tableSchema({
      name: GUIDED_TOURS_SCHEMA,
      columns: [
        { name: "completed_steps", type: "string" },
        { name: "sub_module", type: "string" },
        { name: "updated_at", type: "number" },
        { name: "step_name", type: "string" },
        { name: "user_id", type: "string" },
        { name: "module", type: "string" },
      ],
    }),
    tableSchema({
      name: RATE_LIST_SCHEMA,
      columns: [
        { name: "validity", type: "number", isOptional: true },
        { name: "rate_list_name", type: "string" },
        { name: "business_id", type: "string" },
        { name: "created_at", type: "number" },
        { name: "updated_at", type: "number" },
      ],
    }),
    tableSchema({
      name: RATE_LIST_LINES_SCHEMA,
      columns: [
        { name: "minimum_order_quantity", type: "number", isOptional: true },
        { name: "is_secondary_unit", type: "boolean", isOptional: true },
        { name: "unit_conversion", type: "number", isOptional: true },
        { name: "discount_method", type: "string", isOptional: true },
        { name: "secondary_unit", type: "string", isOptional: true },
        { name: "transacted_at", type: "number", isOptional: true },
        { name: "selling_price", type: "number", isOptional: true },
        { name: "rate_list_id", type: "string", isOptional: true },
        { name: "inclusive", type: "boolean", isOptional: true },
        { name: "cost_price", type: "number", isOptional: true },
        { name: "stock_id", type: "string", isOptional: true },
        { name: "tran_type", type: "string", isOptional: true },
        { name: "discount", type: "number", isOptional: true },
        { name: "type", type: "string", isOptional: true },
        { name: "unit", type: "string", isOptional: true },
        { name: "tax", type: "number", isOptional: true },
        { name: "business_id", type: "string" },
        { name: "quantity", type: "number" },
        { name: "name", type: "string" },
      ],
    }),
    tableSchema({
      name: SIGNATURES_SCHEMA,
      columns: [
        { name: "updated_at", type: "number" },
        { name: "created_at", type: "number" },
        { name: "sign_url", type: "string" },
        { name: "user_id", type: "string" },
      ],
    }),
  ],
});
